// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heffpywmNQ8w9r4QnLrn{width:44px;height:40px;color:var(--content-primary-tertiary);cursor:pointer;border-radius:6px;justify-content:center;align-items:center;margin-bottom:2px;font-size:18px;display:flex}.heffpywmNQ8w9r4QnLrn.fsyOoOmLYEsjHLp7t5cO,.heffpywmNQ8w9r4QnLrn:hover{background:var(--background-neutral-default);color:var(--content-primary-tertiary)}.heffpywmNQ8w9r4QnLrn.fsyOoOmLYEsjHLp7t5cO{box-shadow:0 4px 12px -2px rgba(18,19,23,.03)}.U4hj4yaJLE4acMIcQu0d{height:100%}.U4hj4yaJLE4acMIcQu0d .E8ZtPVGWwmAfCMgQ8ABC{border:none;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `heffpywmNQ8w9r4QnLrn`,
	"active": `fsyOoOmLYEsjHLp7t5cO`,
	"iframeWrapper": `U4hj4yaJLE4acMIcQu0d`,
	"iframe": `E8ZtPVGWwmAfCMgQ8ABC`
};
export default ___CSS_LOADER_EXPORT___;
